import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Logout16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_385)'>
      <path
        d='M8.25004 2.06065L6.28037 4.03032L5.21971 2.96966L7.36616 0.823209C7.85432 0.335052 8.64577 0.335054 9.13393 0.823209L15.4268 7.1161C15.915 7.60426 15.915 8.39571 15.4268 8.88387L9.13393 15.1768C8.64577 15.6649 7.85431 15.6649 7.36616 15.1768L5.21971 13.0303L6.28037 11.9697L8.25004 13.9393L14.1894 7.99999L8.25004 2.06065Z'
        fill='currentColor'
      />
      <path
        d='M3.06059 7.25H10.25V8.75H3.06059L4.28026 9.96967L3.2196 11.0303L0.18927 8L3.2196 4.96967L4.28026 6.03033L3.06059 7.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_385'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Logout16.displayName = 'Logout16';
export default Logout16;
